import { makeHttpRequest } from "@/shared";

import { mapNotificationSettingsFromServer } from "./mappers/mapNotificationSettingsFromServer";
import { mapNotificationSettingsToServer } from "./mappers/mapNotificationSettingsToServer";

export const updateNotificationSettings = async (settings) => {
    const response = (
        await makeHttpRequest({
            url: `/notification-settings`,
            method: "PUT",
            data: mapNotificationSettingsToServer(settings),
        })
    ).data;

    return mapNotificationSettingsFromServer(response);
};
